import {
  BookOpen,
  Check,
  CircleSlash,
  Compass,
  Database,
  FileSearch,
  FlaskConical,
  GanttChartSquare,
  Library,
  LucideShieldCheck,
  ScrollText,
  Sigma,
  Sparkles,
  TrendingUp,
  UserRound
} from "lucide-react";
import { createElement } from "react";

export const lucideIcons = {
  BookOpen,
  Check,
  CircleSlash,
  Compass,
  Database,
  FileSearch,
  FlaskConical,
  GanttChartSquare,
  Library,
  ScrollText,
  ShieldCheck: LucideShieldCheck,
  Sigma,
  Sparkles,
  TrendingUp,
  UserRound
};

export function LucideIcon({ name, size = 18, className = "" }) {
  const Component = lucideIcons[name] ?? Compass;
  return createElement(Component, {
    "aria-hidden": "true",
    size,
    strokeWidth: 1.8,
    className
  });
}
